import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

/**
 * The bank's search box, asking the AI assistant's photo search for the
 * photos of a project that match what was typed.
 *
 * Answers `{ view, total, inOpenFolder?, interpreted, criteria, ... }`: the
 * same `project_bank_photo_filter` view the assistant's panel puts on the
 * bank, or `view: null` when nothing matched. A 403 carries a `code` —
 * `nerobotti_<reason>` for the door, `project_not_available` for the
 * project — on `error.response.data`.
 * @param {{projectId: string, query: string, folderId?: string}} params
 * @returns {Promise<Object>}
 */
export const postNerobottiPhotoSearch = async ({
  projectId,
  query,
  folderId,
}) => {
  const apiPath = 'nerobotti/photo-search';
  const payload = {
    projectId,
    query,
    ...(folderId ? { folderId } : {}),
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload), // aws4 looks for body; axios for data
    data: payload,
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
